import React from 'react';
import { Box} from '@mui/material';
import { Container } from '@mui/material';

import UpdateInspectionAgencyBranchForm from '../Components/UpdateInspectionAgencyBranchForm';

export default function UpdateInspectionAgencyBranchPage() {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <Container>
        <UpdateInspectionAgencyBranchForm/>
      </Container>
    </Box>
  )
}
